<template>
  <ConclusionStep
    :status="portabilityRequestConclusion.status"
    :title="portabilityRequestConclusion.title"
    :description="portabilityRequestConclusion.description"
    @close="handleClose"
  >
    <ContentDisplay class="portability-conclusion__card" :blocks-length="2">
      <template #content-block-1>
        <HeadingDisplay
          :title="portabilityRequestConclusion.portability.title"
          :subtitle="
            portabilityRequestConclusion.portability.custodian.formatted
          "
          size="small"
          avatar-type="char"
          :avatar-content="custodianInitialChar"
        />
      </template>
      <template #content-block-2>
        <ListDisplay
          v-for="(item, index) in portabilityRequestConclusion.portability
            .details"
          :key="index"
          class="portability-conclusion__card__item"
          :title="item.label"
          :value="item.value"
        />
      </template>
    </ContentDisplay>
    <template #button-primary>
      <ButtonPrimary label="Fechar" @click="handleClose" />
    </template>
  </ConclusionStep>
</template>

<script setup lang="ts">
import { inject, computed, Ref } from 'vue';
import { useRouter } from 'vue-router/composables';

import {
  ConclusionStep,
  ButtonPrimary,
  ContentDisplay,
  ListDisplay,
  HeadingDisplay
} from '@warrenbrasil/nebraska-web';

import { PortabilityRequestConclusionResponse } from '@/modules/trade/services/portability';

const portabilityRequestConclusion = inject(
  'portabilityRequestConclusion'
) as Ref<PortabilityRequestConclusionResponse>;

const router = useRouter();

const handleClose = () => {
  router.push({ name: 'home' });
};

const custodianInitialChar = computed(() => {
  return portabilityRequestConclusion.value.portability.custodian.formatted[0];
});
</script>

<style lang="less" scoped>
.portability-conclusion {
  &__card {
    margin-top: @size-spacing-x500;
    &__item:not(:first-child) {
      padding-top: @size-spacing-x350;
    }
  }
}
</style>
